import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

export default function KidsFeature() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/kids-stories?limit=3").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <section data-testid={T.kidsFeature} className="theme-kids relative py-24 sm:py-32">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FDF5E6] to-[#FAE8D8] -z-10" aria-hidden />
      <div className="container-editorial">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-12">
          <div className="md:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-terracotta text-background text-[11px] uppercase tracking-widest">
              <Sparkles className="h-3 w-3" />
              For Kids & Families
            </div>
            <h2 className="heading-1 mt-5 text-ink">
              Bible stories your children will <em className="italic text-terracotta">love</em>.
            </h2>
            <p className="body-copy mt-5 text-ink-muted max-w-xl">
              A gentle, illustrated storybook space — the true stories of the Bible, told well for young hearts.
            </p>
          </div>
          <div className="md:col-span-5 text-sm text-ink-muted md:text-right">
            <Link to="/kids" className="btn-gold">
              Explore Kids&rsquo; Stories
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((s) => (
            <Link
              key={s.id}
              to={`/kids/${s.slug}`}
              data-testid={T.storybookCard(s.slug)}
              className="storybook-card overflow-hidden flex flex-col"
            >
              {s.image_url && (
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={s.image_url}
                    alt={s.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    width="800"
                    height="600"
                  />
                </div>
              )}
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-terracotta/15 text-terracotta-dark text-[11px] uppercase tracking-widest">
                  Ages {s.age_group}
                </span>
                <h3 className="font-serif text-2xl mt-3 text-ink" style={{ fontWeight: 500 }}>{s.title}</h3>
                <p className="text-sm mt-3 text-ink-muted leading-relaxed">{s.summary}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
